// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2TtVr","signatureBlock":"Footer_signatureBlock__1HA-w","signature":"Footer_signature__2VbIO"};